import Index from '../views/Index.vue'

const routes = [
	{
		path: '/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: Index,
		children: [
		]
	},
	{
		path: '/indexGF',
		name: 'indexGF',
		component: () => import('@/views/IndexGF.vue'),
		children: [
		]
	},
	{
		path: '/news',
		name: 'news',
		component: () => import('@/views/news.vue'),
		children: [
		]
	},
	{
		path: '/newsContent',
		name: 'newsContent',
		component: () => import('@/views/newsContent.vue'),
		children: [
		]
	},
	{
		path: '/notice',
		name: 'notice',
		component: () => import('@/views/notice.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent',
		name: 'noticeContent',
		component: () => import('@/views/noticeContent.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-01',
		name: 'noticeContent-01',
		component: () => import('@/views/noticeContent-01.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-02',
		name: 'noticeContent-02',
		component: () => import('@/views/noticeContent-02.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-03',
		name: 'noticeContent-03',
		component: () => import('@/views/noticeContent-03.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-04',
		name: 'noticeContent-04',
		component: () => import('@/views/noticeContent-04.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-05',
		name: 'noticeContent-05',
		component: () => import('@/views/noticeContent-05.vue'),
		children: [
		]
	},
	{
		path: '/noticeContent-06',
		name: 'noticeContent-06',
		component: () => import('@/views/noticeContent-06.vue'),
		children: [
		]
	},
	{
		path: '/introduce',
		name: 'introduce',
		component: () => import('@/views/introduce.vue'),
		children: [
		]
	},
	{
		path: '/introduceText',
		name: 'introduceText',
		component: () => import('@/views/introduceText.vue'),
		children: [
		]
	},
	{
		path: '/contactUs',
		name: 'contactUs',
		component: () => import('@/views/contactUs.vue'),
		children: [
		]
	},
	{
		path: '/shougangbixuan',
		name: 'shougangbixuan',
		component: () => import('@/views/shougangbixuan/index.vue'),
		children: [
		]
	},
	{
		path: '/shoppingMallIndex',
		name: 'shoppingMallIndex',
		component: () => import('@/views/shoppingMallIndex.vue'),
		children: [
		]
	},
	{
		path: '/indexNewGF',
		name: 'indexNewGF',
		component: () => import('@/views/indexNewGF.vue'),
		children: [
		]
	},
	{
		path: '/newsGF',
		name: 'newsGF',
		component: () => import('@/views/guFenXinWen/news.vue'),
		children: [
		]
	},
	{
		path: '/newsContentGF',
		name: 'newsContentGF',
		component: () => import('@/views/guFenXinWen/newsContent.vue'),
		children: [
		]
	},
	{
		path: '/404',
		name: 'PageNotFound',
		component: () => import('@/views/404.vue')
	},
]

export default routes